import React from 'react';
import { Link } from 'react-router';
import Header from '../Layout/Header';
import Footer from '../Layout/Footer/Footer';
import DashboardNavigation from './DashboardNav';
import DashboardAddress from './DashboardAddress';
import { serializeSpecialChars, extensionDetect, adminUserIds, disabledCart } from '../../utils/utils';
import { filterWarehouse } from '../../utils/whiteListed';
import { isMobile } from 'react-device-detect';
import Countdown from './Countdown';
/* eslint-disable */
const appConfig = require('webpack-config-loader!../../app-config.js');
const extensionId = appConfig.extensionId;
/* eslint-enable */
const createReactClass = require('create-react-class');
const DefaultDashboardBody = createReactClass({


  componentDidMount() {
    window.scrollTo(0, 0);
    window.addEventListener('resize', this.updateWindowDimensions);
  },

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  },

  componentWillMount() {
    const token = localStorage.jwtToken;
    this.props.signedIn(token);
    localStorage.setItem("TourFinish", "false");
    this.props.getCopyrightYear();
    this.props.getCartBanner()

    const isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
    const isMac = navigator.userAgent.toLowerCase().indexOf('mac') > -1;
    if(isChrome){
      if(isMac) {
        localStorage.setItem("cartExtensionModalShowed", true)
      } else {
        extensionDetect(extensionId)
      }
    }else{
      localStorage.setItem("cartExtensionModalShowed", true)
    }
  },
  getInitialState: function () {
    return {
      cmsList: [],
      first_name: '',
      last_name:'',
      account_number: '',
      phone_number: '',
      enabledCart: false,
      prevPath: '',
    }
  },
  componentWillReceiveProps(nextProps) {
    if(nextProps.login.login.party){
      const enabledCart = adminUserIds.find(e => e === nextProps.login.login.party.account_number)
      this.setState({
        first_name: serializeSpecialChars(nextProps.login.login.party.first_name),
        last_name: serializeSpecialChars(nextProps.login.login.party.last_name),
        account_number: nextProps.login.login.party.account_number,
        phone_number: nextProps.login.login.party.phone_number,
        enabledCart: enabledCart ? true : false
      });
    }
    if (disabledCart && nextProps.location !== this.props.location) {
      this.setState({ prevPath: nextProps.location })
    }
  },
  handleLogout() {
    localStorage.removeItem('jwtToken');
    this.props.logout();
  },
  updateWindowDimensions () {
    this.setState({ width: window.innerWidth });
  },
  hanldeBannerLink(link) {
    if (link.includes('shippingcart.com')) {
      return link.split('shippingcart.com')[1];
    }
    return link;
  },
  render() {
    // let warehouse = this.props.customerInfo.warehouse_fetched ? this.props.customerInfo.warehouse.data : null;
    const cartBanner = this.props.cms.cartBanner && this.props.cms.getCartBanner.data[0];
    return (
          <div>
            <Header
              isAuthenticated={true}
              login={this.props.login}
              logout={this.handleLogout}
            />
              <div className="body-wrapper">
                <div className="customer storage">
                  <div className="container">
                    <div className="customer-wrapper">
                      {cartBanner && cartBanner.status === 1 && <div className="dashboard-ad">
                        {isMobile || this.state.width < '960' || window.innerWidth < '960' ? 
                          <Link to={cartBanner.redirection_mobile_link ? this.hanldeBannerLink(cartBanner.redirection_mobile_link) : this.hanldeBannerLink(cartBanner.redirection_web_link)} target="_blank">
                            <img src={cartBanner.banner_mobile_url ? cartBanner.banner_mobile_url : cartBanner.banner_web_url} alt="banner-ad" style={{maxHeight: '100px'}}/>
                          </Link> :
                          <Link to={this.hanldeBannerLink(cartBanner.redirection_web_link)} target="_blank">
                            <div>
                              <img src={cartBanner.banner_web_url} alt="banner-ad" style={cartBanner.ended_timer_at ? {width: '80%', height: '55px'} : {width: '100%', maxHeight: '55px'}}/>
                              {cartBanner.ended_timer_at && <Countdown date={cartBanner.ended_timer_at}/>}
                            </div>
                          </Link>
                         }
                      </div>}
                      <aside className="address-sidebar">
                      {this.props.customerInfo.warehouse_fetched ? filterWarehouse(this.props.customerInfo.warehouse.data, this.props.login.login.party).map((address,key) =>
                        <DashboardAddress 
                          first_name={this.state.first_name}
                          last_name={this.state.last_name}
                          account_number={this.state.account_number}
                          key={key}
                          address={address}
                          unTrimmedAddress={true}
                          highlightOregon={true}
                        /> ): <div className="address-box"></div>}
                        <div className="shadow"></div>
                        <div className="side-banner">
                          <div className="wrapper">
                            <Link to="#" target="_blank">
                              <div className="side-img"></div></Link>
                          </div>
                        </div>
                        <div className="shadow"></div>
                      </aside>
                      <a id="hashtabs" name="hashtabs">{""}</a>
                      <div className="main" role="main">
                        <div className="main-header">

                        </div>
                        <div className="main-wrapper">
                          <DashboardNavigation
                            fetchProhibited={this.props.parcelInfo.prohibited_fetching}
                            prohibited={this.props.parcelInfo.prohibited}
                            fetchCart={this.props.parcelInfo.cart_fetching}
                            offsize={this.props.parcelInfo.cartData && this.props.parcelInfo.cartData.offsizeItems}
                            enabledCart={this.state.enabledCart}
                            prevPath={this.state.prevPath}
                          />
                          {React.cloneElement({ ...this.props, }.children, { ...this.props, })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer
                currentPath={this.props.location.pathname}
                currentYear={this.props.login.year}
              />
            </div>
        );
  },
});

export default DefaultDashboardBody;



/** WEBPACK FOOTER **
 ** ./src/components/Dashboard/DefaultDashboardBody.js
 **/